// extracted by mini-css-extract-plugin
module.exports = {"title":"_4240dccd497492ca0992f938e4e19f2d-less"};